import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

import { registerUser } from "../../services/api/authentication";

import { ModalTerms } from "../../components/modalTerms";

import User from "../../models/User";

import { APP_URL } from "../../util/constants/APP_URL";
import { isMobile } from "../../util/methods/responsive";

import asgImage from "../../assets/images/ASG.png";
import femaleMaleImage from "../../assets/images/female_male.png";
import loadingIcon from "../../assets/images/loading.gif";
import misionImage from "../../assets/images/MISION.png";

const Register = () => {
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    terms: Yup.bool()
      .required()
      .oneOf([true], "Debe aceptar los términos y condiciones."),
    email: Yup.string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        "Debe ingresar un correo válido."
      )
      .required("Debe ingresar un correo válido."),
    dni: Yup.string()
      .required("DNI es obligatorio.")
      .min(8, "El DNI debe tener al menos 8 dígitos."),
    password: Yup.string().required("La contraseña es requerida."),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };

  const {
    register,
    handleSubmit,
    formState: { isValid },
    setValue,
    reset,
  } = useForm({
    mode: "onChange",
    ...formOptions,
  });

  const [message, setMessage] = useState<string>("");
  const [status, setStatus] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const redirectoTo = (url: string) => {
    navigate(url);
  };

  const onSubmit = async (data: any) => {
    setMessage("");
    setStatus(false);

    const newUser = new User({
      email: data.email,
      dni: data.dni,
      password: data.password,
    });

    if (newUser.validateFields() && data.terms) {
      setIsLoading(true);

      await registerUser(newUser)
        .then((result) => {
          if (result.status) {
            setStatus(true);
            reset();
            setValue('terms', false);
            setMessage(
              "Su usuario y contraseña han sido enviados al correo que indicó en el registro."
            );

            setTimeout(() => {
              navigate(APP_URL.AUTHENTICATION.LOGIN)
            }, 2500);
          } else {
            setStatus(false);
            setMessage(result.error.message);
          }
        })
        .catch((err) => {
          console.log({ err });
        })
        .finally(() => {
          setIsLoading(false);
        });


    }
  };

  const acceptTerms = () => {
    setValue("terms", true, { shouldValidate: true });
    setShowModal(false);
  };

  return (
    <>
      {
        isLoading && (
          <div className="loading_all_page">
            <img src={loadingIcon} alt="loading" width="120" height="120" />
          </div>
        )
      }
      <section className="background-form">
        <div className="image-section">
          <div>
            <div>
              <img src={femaleMaleImage} alt="mision" />
            </div>
          </div>
        </div>
        <div className="width-full height-full">
          <div className="pt-8-per left-0 right-0">
            <div className="bar-asg">
              <div>
                <img src={misionImage} alt="mision" />
                <img src={asgImage} alt="ASG" />
              </div>
            </div>
          </div>
          <div className="width-full flex justify-content-center align-center relative">
            <div className="inputs-section">
              <div>
                <p className="title ft-EricssonGA628">REGISTRATE</p>
                <div className="form">
                  <form>
                    <div className="form-section">
                      <input
                        type="text"
                        placeholder="Escribe tu DNI"
                        maxLength={8}
                        {...register("dni", {
                          required: "DNI es obligatorio.",
                          minLength: {
                            value: 8,
                            message: "El DNI debe tener al menos 8 dígitos.",
                          },
                        })}
                        onKeyDown={(e) => {
                          if (e.key === " ") e.preventDefault();
                        }}
                      />
                    </div>
                    <div className="form-section">
                      <input
                        type="text"
                        placeholder="Escribe tu correo"
                        {...register("email", {
                          required: "El email es obligatorio",
                        })}
                        onKeyDown={(e) => {
                          if (e.key === " ") e.preventDefault();
                        }}
                      />
                    </div>
                    <div className="form-section">
                      <input
                        type="text"
                        placeholder="Crea tu contraseña"
                        {...register("password", {
                          required: "La contraseña es requerida",
                        })}
                        onKeyDown={(e) => {
                          if (e.key === " ") e.preventDefault();
                        }}
                      />
                    </div>
                  </form>
                </div>
              </div>
              <div className="error-section-register">
                <p className={`ft-EricssonGA628 ${status ? "success" : ""}`}>
                  {message}
                </p>
              </div>
              <div className="flex justify-content-center">
                <div className="flex gap-2 terms">
                  <input type="checkbox" {...register("terms")} />
                  <p
                    className="ft-rbt--r pointer"
                    onClick={() => setShowModal(true)}
                  >
                    Acepto las condiciones y descargo de
                    {isMobile() ? <span> </span> : <br />}
                    responsabilidad.
                  </p>
                </div>
              </div>
              <div className="flex justify-content-center button-submit flex-column align-items-center gap-3">
                <button onClick={handleSubmit(onSubmit)} disabled={!isValid}>
                  <span className="ft-EricssonGA628">Registrar</span>
                  {
                    isLoading &&
                    <img src={loadingIcon} alt="loading" width="35" height="35" />
                  }
                </button>
                <p
                  className="pie-title ft-EricssonGA628"
                  onClick={() => redirectoTo(APP_URL.AUTHENTICATION.LOGIN)}
                >
                  Iniciar sesión
                </p>

                <p
                  className="pie-title ft-EricssonGA628 subtitle-home"
                  onClick={() => redirectoTo(APP_URL.AUTHENTICATION.RECOVERY)}
                >
                  Recuperar contraseña
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showModal && (
        <ModalTerms
          closeModal={() => setShowModal(false)}
          onAceptTerms={() => acceptTerms()}
        />
      )}
    </>
  );
};

export default Register;
